import React, { Component } from "react"
import Slider from "../slider/slider"
import { isMobile } from "react-device-detect"

import "./_logo-slider.scss"

class LogoSlider extends Component {
  static defaultProps = {
    data: [
      {
        ImageAltText: "Biotherm",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_biotherm@2x.png",
      },
      {
        ImageAltText: "Chanel",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_chanel@2x.png",
      },
      {
        ImageAltText: "Clarins",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_clarins@2x.png",
      },
      {
        ImageAltText: "Clinique",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_clinique@2x.png",
      },
      {
        ImageAltText: "Dior",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_dior@2x.png",
      },
      {
        ImageAltText: "Elizabeth Arden",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_elizabetharden@2x.png",
      },
      {
        ImageAltText: "Hugo Boss",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_hugoboss@2x.png",
      },
      {
        ImageAltText: "Kerastase",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_kerastase@2x.png",
      },
      {
        ImageAltText: "Kiehls",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_kiehls@2x.png",
      },
      {
        ImageAltText: "La Mer",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_lamer@2x.png",
      },
      {
        ImageAltText: "MAC",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_mac@2x.png",
      },
      {
        ImageAltText: "Anthon Berg",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_anthonberg@2x.png",
      },
      {
        ImageAltText: "Ferrero Rocher",
        LinkUrl: "#",
        ImageUrl: "/static/newshop/logos/logo_ferrerorocher@2x.png",
      },
    ],
  }

  render() {
    let params = {
      freeMode: isMobile,
      slidesPerView: 3,
      spaceBetween: 20,
      initialSlide: Math.round(this.props.data.length / 2) - 1,
      breakpoints: {
        1280: {
          slidesPerView: 8,
          spaceBetween: 40,
          slidesPerGroup: 2,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 40,
          slidesPerGroup: 2,
        },
        750: {
          slidesPerView: 5,
          spaceBetween: 10,
          slidesPerGroup: 1,
        },
      },
    }

    return (
      <div className="logo-slider">
        <Slider params={params}>
          {this.props.data.map((item, index) => {
            return (
              <div key={`logoSlide${index}`}>
                <a href={item.LinkUrl}>
                  <img src={item.ImageUrl} alt={item.ImageAltText} />
                </a>
              </div>
            )
          })}
        </Slider>
      </div>
    )
  }
}

export default LogoSlider
